import React, {useEffect} from 'react';
import {Text} from '@gravity-ui/uikit';
import styles from './BenefactorSubscriptions.module.scss';
import {useBenefactorSubscriptions} from '../../hooks';
import {SubscriptionFilter} from '../../model';
import {useErrorHandler, ErrorModal} from '../../../../shared';
import {CancelledSubscriptions, ActiveSubscriptions} from './components';

interface BenefactorSubscriptionsProps {
  benefactorId?: string;
}

export const BenefactorSubscriptions: React.FC<BenefactorSubscriptionsProps> = ({benefactorId}) => {
  const {handleError, isErrorModalOpen, errorInfo, handleClose} = useErrorHandler({
    resourceName: 'Подписки',
    title: 'Ошибка при получении подписок',
  });

  const {getSubscriptions: getActiveSubscriptions} = useBenefactorSubscriptions(
    benefactorId || '',
    SubscriptionFilter.Active,
  );

  const {getSubscriptions: getInactiveSubscriptions} = useBenefactorSubscriptions(
    benefactorId || '',
    SubscriptionFilter.Inactive,
  );

  useEffect(() => {
    if (getActiveSubscriptions.error) {
      handleError(getActiveSubscriptions.error as unknown as ApiError);
    }
  }, [getActiveSubscriptions.error, handleError]);

  useEffect(() => {
    if (getInactiveSubscriptions.error) {
      handleError(getInactiveSubscriptions.error as unknown as ApiError);
    }
  }, [getInactiveSubscriptions.error, handleError]);

  if (!benefactorId) {
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <Text variant="body-1">Не указан ID пользователя</Text>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.sectionsContainer}>
          <div>
            <ActiveSubscriptions
              subscriptions={getActiveSubscriptions.data?.items || []}
              isLoading={getActiveSubscriptions.isLoading}
            />
          </div>

          {getInactiveSubscriptions.data?.items.length ? (
            <CancelledSubscriptions
              subscriptions={getInactiveSubscriptions.data?.items || []}
              isLoading={getInactiveSubscriptions.isLoading}
            />
          ) : null}
        </div>
      </div>

      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </div>
  );
};
